// // components/superadmin/AllAdminsOverview.jsx
// import { useEffect, useState } from "react";
// import { Mail, Users, Building2, Calendar, Eye, Crown, UserCheck, Briefcase } from "lucide-react";

// export default function AllAdminsOverview() {
//   const [data, setData] = useState(null);
//   const [selectedAdmin, setSelectedAdmin] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetch(`${process.env.REACT_APP_API_URL}superadmin/dashboard`, {
//       headers: { 
//         "Authorization": `Bearer ${localStorage.getItem("token")}`,
//         "Content-Type": "application/json"
//       }
//     })
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to fetch");
//         return res.json();
//       })
//       .then(fetchedData => {
//         console.log("Full data from backend:", fetchedData); // Check console
//         setData(fetchedData);
//         setLoading(false);
//       })
//       .catch(err => {
//         console.error(err);
//         alert("Error loading dashboard");
//         setLoading(false);
//       });
//   }, []);

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         <p className="text-2xl">Loading your empire... 👑</p>
//       </div>
//     );
//   }

//   if (!data) return <p>No data</p>;

//   const { admins, stats } = data;
//   const { totalAdmins, totalSeekers, totalEmployers, adminCreatedSeekers, adminStats } = stats;

//   return (
//     <div className="p-6 max-w-7xl mx-auto bg-gray-50 min-h-screen">
//       <div className="text-center mb-10">
//         <h1 className="text-5xl font-bold text-purple-800 flex items-center justify-center gap-4">
//           <Crown className="w-14 h-14 text-yellow-500" />
//           SuperAdmin Empire Control
//           <Crown className="w-14 h-14 text-yellow-500" />
//         </h1>
//         <p className="text-xl text-gray-600 mt-2">You get full power over everything!</p>
//       </div>

//       {/* BIG STATS CARDS */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
//         <div className="bg-gradient-to-br from-purple-600 to-purple-800 text-white p-8 rounded-2xl shadow-2xl transform hover:scale-105 transition">
//           <UserCheck className="w-12 h-12 mb-4" />
//           <p className="text-5xl font-bold">{totalAdmins}</p>
//           <p className="text-xl opacity-90">Total Admins</p>
//         </div>

//         <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white p-8 rounded-2xl shadow-2xl transform hover:scale-105 transition">
//           <Users className="w-12 h-12 mb-4" />
//           <p className="text-5xl font-bold">{totalSeekers}</p>
//           <p className="text-xl opacity-90">Total Job Seekers</p>
//         </div>

//         <div className="bg-gradient-to-br from-green-600 to-green-800 text-white p-8 rounded-2xl shadow-2xl transform hover:scale-105 transition">
//           <Building2 className="w-12 h-12 mb-4" />
//           <p className="text-5xl font-bold">{totalEmployers}</p>
//           <p className="text-xl opacity-90">Total Employers</p>
//         </div>

//         <div className="bg-gradient-to-br from-orange-600 to-red-600 text-white p-8 rounded-2xl shadow-2xl transform hover:scale-105 transition">
//           <Briefcase className="w-12 h-12 mb-4" />
//           <p className="text-5xl font-bold">{adminCreatedSeekers}</p>
//           <p className="text-xl opacity-90">Created by Admins</p>
//         </div>
//       </div>

//       {/* ALL ADMINS LIST */}
//       <h2 className="text-3xl font-bold text-gray-800 mb-6">Your Admins ({totalAdmins})</h2>
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//         {adminStats?.map((admin) => (
//           <div key={admin._id} className="bg-white rounded-2xl shadow-xl border border-purple-200 hover:shadow-2xl transition p-8">
//             <div className="flex justify-between items-start mb-6">
//               <div>
//                 <h3 className="text-2xl font-bold text-gray-800">{admin.name}</h3>
//                 <p className="text-gray-600 flex items-center gap-2 mt-1">
//                   <Mail className="w-5 h-5" /> {admin.email}
//                 </p>
//               </div>
//               <button
//                 onClick={() => setSelectedAdmin(admin)}
//                 className="bg-purple-600 text-white p-4 rounded-full hover:bg-purple-700 transition"
//               >
//                 <Eye className="w-6 h-6" />
//               </button>
//             </div>

//             <div className="space-y-4 text-lg">
//               <div className="flex justify-between items-center bg-blue-50 p-4 rounded-lg">
//                 <span className="flex items-center gap-3"><Users className="text-blue-700" /> Seekers Created</span>
//                 <span className="font-bold text-3xl text-blue-700">{admin.seekersCount}</span>
//               </div>
//               <div className="flex justify-between items-center bg-green-50 p-4 rounded-lg">
//                 <span className="flex items-center gap-3"><Building2 className="text-green-700" /> Employers Created</span>
//                 <span className="font-bold text-3xl text-green-700">{admin.employersCount}</span>
//               </div>
//               <p className="text-sm text-gray-500 text-center mt-4 flex items-center justify-center gap-2">
//                 <Calendar className="w-4 h-4" />
//                 Joined: {new Date(admin.createdAt).toLocaleDateString("en-GB")}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* MODAL */}
//       {selectedAdmin && (
//         <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-3xl p-10 max-w-4xl w-full max-h-screen overflow-y-auto shadow-2xl">
//             <h2 className="text-4xl font-bold text-purple-700 mb-8 text-center">
//               {selectedAdmin.name}'s Kingdom Report
//             </h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
//               <div className="text-center bg-gradient-to-br from-blue-100 to-blue-200 p-10 rounded-2xl">
//                 <Users className="w-20 h-20 text-blue-700 mx-auto mb-4" />
//                 <p className="text-6xl font-bold text-blue-800">{selectedAdmin.seekersCount}</p>
//                 <p className="text-2xl mt-2">Job Seekers Created</p>
//               </div>
//               <div className="text-center bg-gradient-to-br from-green-100 to-green-200 p-10 rounded-2xl">
//                 <Building2 className="w-20 h-20 text-green-700 mx-auto mb-4" />
//                 <p className="text-6xl font-bold text-green-800">{selectedAdmin.employersCount}</p>
//                 <p className="text-2xl mt-2">Employers Created</p>
//               </div>
//             </div>
//             <button
//               onClick={() => setSelectedAdmin(null)}
//               className="mt-10 w-full bg-red-600 text-white py-5 rounded-xl text-xl font-bold hover:bg-red-700 transition"
//             >
//               Close Report
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// components/superadmin/AllAdminsOverview.jsx   (FINAL – EVERYTHING IMPLEMENTED)
import { useEffect, useState } from "react";
import { 
  Mail, Users, Building2, Calendar, Eye, Crown, TrendingUp, 
  Activity, Clock, ChevronRight, X, Award, UserCheck 
} from "lucide-react";

export default function AllAdminsOverview() {
  const [data, setData] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}superadmin/dashboard`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    })
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(fetchedData => {
        setData(fetchedData);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-xl">Loading Empire...</div>;
  if (!data || !data.stats) return <p className="text-center text-red-600">No data</p>;

  const { totalAdmins, totalSeekers, totalEmployers, adminCreatedSeekers, adminStats } = data.stats;

  // Find top performers
  const topSeekerAdmin = adminStats?.reduce((prev, current) => 
    (prev.seekersCount > current.seekersCount) ? prev : current, { seekersCount: 0 });
  const topEmployerAdmin = adminStats?.reduce((prev, current) => 
    (prev.employersCount > current.employersCount) ? prev : current, { employersCount: 0 });

  return (
    <div className="p-6 max-w-7xl mx-auto bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-purple-800 flex items-center justify-center gap-4">
          <Crown className="w-10 h-10 text-yellow-500" />
          SuperAdmin Empire Control
          <Crown className="w-10 h-10 text-yellow-500" />
        </h1>
        <p className="text-lg text-gray-600 mt-2">Full visibility over every admin and their kingdom</p>
      </div>

      {/* Empire Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
        <div className="bg-white p-6 rounded-xl shadow text-center">
          <UserCheck className="w-12 h-12 text-purple-600 mx-auto mb-3" />
          <p className="text-3xl font-bold">{totalAdmins}</p>
          <p className="text-gray-600">Total Admins</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow text-center">
          <Users className="w-12 h-12 text-blue-600 mx-auto mb-3" />
          <p className="text-3xl font-bold">{totalSeekers}</p>
          <p className="text-gray-600">Total Seekers</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow text-center">
          <Building2 className="w-12 h-12 text-green-600 mx-auto mb-3" />
          <p className="text-3xl font-bold">{totalEmployers}</p>
          <p className="text-gray-600">Total Employers</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow text-center">
          <TrendingUp className="w-12 h-12 text-orange-600 mx-auto mb-3" />
          <p className="text-3xl font-bold">{adminCreatedSeekers}</p>
          <p className="text-gray-600">Admin-Created</p>
        </div>
      </div>

      {/* Top Performers */}
      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-8 rounded-2xl shadow-lg">
          <div className="flex items-center gap-4 mb-4">
            <Award className="w-12 h-12 text-blue-600" />
            <h3 className="text-2xl font-bold">Top Seeker Creator</h3>
          </div>
          <p className="text-4xl font-bold text-blue-700">{topSeekerAdmin?.name || "N/A"}</p>
          <p className="text-xl text-gray-700">{topSeekerAdmin?.seekersCount || 0} seekers created</p>
        </div>
        <div className="bg-gradient-to-r from-green-50 to-green-100 p-8 rounded-2xl shadow-lg">
          <div className="flex items-center gap-4 mb-4">
            <Award className="w-12 h-12 text-green-600" />
            <h3 className="text-2xl font-bold">Top Employer Creator</h3>
          </div>
          <p className="text-4xl font-bold text-green-700">{topEmployerAdmin?.name || "N/A"}</p>
          <p className="text-xl text-gray-700">{topEmployerAdmin?.employersCount || 0} employers created</p>
        </div>
      </div>

      {/* Admins Grid */}
      <h2 className="text-2xl font-bold mb-6">All Admins ({totalAdmins})</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {adminStats?.map(admin => (
          <div 
            key={admin._id} 
            className="bg-white rounded-xl shadow hover:shadow-xl transition cursor-pointer p-6 border"
            onClick={() => setSelectedAdmin(admin)}
          >
            <div className="flex justify-between items-start mb-4">
              <div>
                <h3 className="text-xl font-bold">{admin.name}</h3>
                <p className="text-gray-600 flex items-center gap-2">
                  <Mail className="w-4 h-4" /> {admin.email}
                </p>
              </div>
              <Eye className="w-8 h-8 text-purple-600" />
            </div>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="flex items-center gap-2"><Users className="w-5 h-5 text-blue-600" /> Seekers</span>
                <span className="font-bold text-xl">{admin.seekersCount}</span>
              </div>
              <div className="flex justify-between">
                <span className="flex items-center gap-2"><Building2 className="w-5 h-5 text-green-600" /> Employers</span>
                <span className="font-bold text-xl">{admin.employersCount}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Detailed Modal */}
      {selectedAdmin && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-6xl w-full max-h-screen overflow-y-auto p-8">
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-3xl font-bold text-purple-700">{selectedAdmin.name}'s Full Report</h2>
              <button onClick={() => setSelectedAdmin(null)} className="p-2 hover:bg-gray-100 rounded-lg">
                <X className="w-8 h-8" />
              </button>
            </div>

            {/* Summary Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
              <div className="bg-blue-50 p-6 rounded-xl text-center">
                <Users className="w-12 h-12 text-blue-600 mx-auto mb-3" />
                <p className="text-4xl font-bold text-blue-700">{selectedAdmin.seekers?.length || 0}</p>
                <p className="text-lg">Seekers Created</p>
              </div>
              <div className="bg-green-50 p-6 rounded-xl text-center">
                <Building2 className="w-12 h-12 text-green-600 mx-auto mb-3" />
                <p className="text-4xl font-bold text-green-700">{selectedAdmin.employers?.length || 0}</p>
                <p className="text-lg">Employers Created</p>
              </div>
              <div className="bg-purple-50 p-6 rounded-xl text-center">
                <Activity className="w-12 h-12 text-purple-600 mx-auto mb-3" />
                <p className="text-4xl font-bold text-purple-700">{(selectedAdmin.seekers?.length || 0) + (selectedAdmin.employers?.length || 0)}</p>
                <p className="text-lg">Total Created</p>
              </div>
            </div>

            {/* Daily Creation Chart */}
            {selectedAdmin.dailyStats && selectedAdmin.dailyStats.length > 0 && (
              <div className="mb-10">
                <h3 className="text-xl font-bold mb-4">Daily Creation Activity</h3>
                <div className="bg-gray-50 p-6 rounded-xl">
                  <div className="space-y-3">
                    {selectedAdmin.dailyStats.map((day, i) => (
                      <div key={i} className="flex items-center justify-between py-3 border-b last:border-0">
                        <span className="font-medium w-32">{day.date}</span>
                        <div className="flex gap-10">
                          <span className="text-blue-700 font-bold">{day.seekers} seekers</span>
                          <span className="text-green-700 font-bold">{day.employers} employers</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Job Seekers Created */}
            <div className="mb-10">
              <h3 className="text-xl font-bold mb-4">Job Seekers Created ({selectedAdmin.seekers?.length || 0})</h3>
              <div className="grid md:grid-cols-2 gap-4 max-h-96 overflow-y-auto">
                {selectedAdmin.seekers?.length > 0 ? selectedAdmin.seekers.map(s => (
                  <div key={s._id} className="bg-blue-50 p-4 rounded-lg">
                    <p className="font-bold">{s.firstName} {s.lastName}</p>
                    <p className="text-sm text-gray-600">{s.email} • {s.phoneNumber}</p>
                    <p className="text-xs text-gray-500">Created: {new Date(s.createdAt).toLocaleDateString()}</p>
                  </div>
                )) : <p className="text-gray-500">No seekers created yet</p>}
              </div>
            </div>

            {/* Employers Created */}
            <div className="mb-10">
              <h3 className="text-xl font-bold mb-4">Employers Created ({selectedAdmin.employers?.length || 0})</h3>
              <div className="grid md:grid-cols-2 gap-4 max-h-96 overflow-y-auto">
                {selectedAdmin.employers?.length > 0 ? selectedAdmin.employers.map(e => (
                  <div key={e._id} className="bg-green-50 p-4 rounded-lg">
                    <p className="font-bold">{e.companyName}</p>
                    <p className="text-sm text-gray-600">{e.email} • {e.phoneNumber}</p>
                    <p className="text-xs text-gray-500">Created: {new Date(e.createdAt).toLocaleDateString()}</p>
                  </div>
                )) : <p className="text-gray-500">No employers created yet</p>}
              </div>
            </div>

            {/* Inside the selectedAdmin modal – REPLACE the bottom part with this */}

{/* Employer Request History */}
<div className="mt-12">
  <h3 className="text-xl font-bold mb-4">Employer Job Requests ({selectedAdmin.requestsMade?.length || 0})</h3>
  <div className="space-y-4 max-h-96 overflow-y-auto">
    {selectedAdmin.requestsMade?.length > 0 ? selectedAdmin.requestsMade.map(r => (
      <div key={r._id} className="bg-orange-50 p-4 rounded-lg border border-orange-200">
        <p className="font-bold">{r.jobPosition} - ₦{r.salary || "Negotiable"}</p>
        <p className="text-sm">Company: {r.employerName}</p>
        <p className="text-sm">Status: <span className={`font-bold ${r.status === "accepted" ? "text-green-600" : r.status === "rejected" ? "text-red-600" : "text-orange-600"}`}>{r.status}</span></p>
        {r.assignedSeeker && <p className="text-sm">Assigned to: {r.assignedSeeker.firstName} {r.assignedSeeker.lastName}</p>}
        {r.rejectionReason && <p className="text-red-600 text-sm">Reason: {r.rejectionReason}</p>}
        <p className="text-xs text-gray-500 mt-2">Requested: {new Date(r.createdAt).toLocaleDateString()}</p>
      </div>
    )) : <p className="text-gray-500">No job requests from their employers yet</p>}
  </div>
</div>

{/* JobSeeker Assignment History */}
<div className="mt-12">
  <h3 className="text-xl font-bold mb-4">JobSeeker Assignments ({selectedAdmin.assignmentHistory?.length || 0})</h3>
  <div className="space-y-4 max-h-96 overflow-y-auto">
    {selectedAdmin.assignmentHistory?.length > 0 ? selectedAdmin.assignmentHistory.map(r => (
      <div key={r._id} className="bg-blue-50 p-4 rounded-lg border border-blue-200">
        <p className="font-bold">{r.assignedSeekerName} → {r.jobPosition}</p>
        <p className="text-sm">Company: {r.employer.companyName}</p>
        <p className="text-sm">Status: <span className={`font-bold ${r.status === "accepted" ? "text-green-600" : r.status === "rejected" ? "text-red-600" : "text-blue-600"}`}>{r.status}</span></p>
        {r.rejectionReason && <p className="text-red-600 text-sm">Reason: {r.rejectionReason}</p>}
        <p className="text-xs text-gray-500 mt-2">Assigned: {new Date(r.assignedAt || r.createdAt).toLocaleDateString()}</p>
      </div>
    )) : <p className="text-gray-500">No assignments for their seekers yet</p>}
  </div>
</div>

            {/* Full History */}
            {selectedAdmin.history && selectedAdmin.history.length > 0 && (
              <div>
                <h3 className="text-xl font-bold mb-4">Activity History</h3>
                <div className="space-y-3">
                  {selectedAdmin.history.map((h, i) => (
                    <div key={i} className="bg-gray-50 p-4 rounded-lg flex justify-between">
                      <span>{h.action}</span>
                      <span className="text-sm text-gray-600">{new Date(h.timestamp).toLocaleString()}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}